const baseURL = "https://hungnamelectric.com";
console.log('baseURL: ' + baseURL)
export { baseURL };

